import { render, staticRenderFns } from "./commonIframe.vue?vue&type=template&id=5ca9bc1a&scoped=true"
import script from "./commonIframe.vue?vue&type=script&lang=js"
export * from "./commonIframe.vue?vue&type=script&lang=js"
import style0 from "./commonIframe.vue?vue&type=style&index=0&id=5ca9bc1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca9bc1a",
  null
  
)

export default component.exports